import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError, fmtDate } from "../lib/api";
import { PageHeader } from "./AdminLayout";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const STATUS_LABELS = { nouveau: "Nouveau", en_cours: "En cours", traite: "Traité" };

export default function Messages() {
    const [items, setItems] = useState(null);

    const load = () => api.get("/admin/contact").then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e)));
    useEffect(() => { load(); }, []);

    const setStatus = async (m, status) => {
        try {
            await api.patch(`/admin/contact/${m.message_id}`, { status });
            toast.success("Statut mis à jour.");
            load();
        } catch (e) {
            toast.error(apiError(e));
        }
    };

    return (
        <div data-testid="admin-messages">
            <PageHeader title="Messages de contact" subtitle="Demandes envoyées via le formulaire public du site." />
            {items && items.length === 0 && <p className="rounded-2xl border-2 border-dashed border-gold/40 bg-white p-10 text-center text-pineneedle" data-testid="messages-empty">Aucun message pour le moment.</p>}
            <div className="space-y-4">
                {(items || []).map((m) => (
                    <article key={m.message_id} className="rounded-2xl bg-white border border-gold/25 p-5 shadow-sm" data-testid={`message-${m.message_id}`}>
                        <div className="flex flex-wrap items-start justify-between gap-3">
                            <div>
                                <p className="font-semibold text-forest">{m.subject}</p>
                                <p className="text-xs text-pineneedle">{m.name} · <a href={`mailto:${m.email}`} className="text-gold hover:underline">{m.email}</a> · {fmtDate(m.created_at)}</p>
                            </div>
                            <Select value={m.status} onValueChange={(v) => setStatus(m, v)}>
                                <SelectTrigger className="w-36 h-8 text-xs" data-testid={`message-status-${m.message_id}`}><SelectValue /></SelectTrigger>
                                <SelectContent>
                                    {Object.entries(STATUS_LABELS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}
                                </SelectContent>
                            </Select>
                        </div>
                        <p className="text-sm text-pineneedle mt-3 whitespace-pre-line leading-relaxed">{m.message}</p>
                    </article>
                ))}
            </div>
        </div>
    );
}
